import { useTranslation } from 'react-i18next';

import type { UsageSupplierDayStatus } from '../types';

const STATUS_STYLES: Record<string, string> = {
  VIA_STOCKERAI_COMPLETO: 'bg-green-50 text-green-800 border-green-200',
  VIA_STOCKERAI_INCOMPLETO: 'bg-amber-50 text-amber-800 border-amber-200',
  FUERA_DE_STOCKERAI: 'bg-red-50 text-red-800 border-red-200',
  NO_LLEGO_AL_ERP: 'bg-orange-50 text-orange-800 border-orange-200',
  NO_COMPARABLE: 'bg-gray-100 text-gray-700 border-gray-300',
};

interface Props {
  status: UsageSupplierDayStatus | string;
  className?: string;
}

export function UsageStatusBadge({ status, className = '' }: Props) {
  const { t } = useTranslation();
  const style = STATUS_STYLES[status] ?? 'bg-gray-100 text-gray-700 border-gray-300';
  const label = t(`adoption.status.${status}`, { defaultValue: status });

  return (
    <span
      className={`inline-flex max-w-full items-center truncate rounded-md border px-2 py-0.5 text-xs font-medium ${style} ${className}`}
      title={label}
    >
      {label}
    </span>
  );
}
